module.exports = __webpack_public_path__ + "img/desktop-chrome_web_li.1b95af46.webp";